import React, { useState } from 'react';
import { Badge } from 'antd';
import type { NavigateFunction } from 'react-router-dom';
import { Icon, Tooltip } from '@hydrodigital/design-system';
import { ChatbotSvg } from '@/assets/svg';
import type { DashboardContextValueInterface } from '@/contexts/DashboardContext';
import type { Module } from '@/domain/Users/Users';
import { showNavItem } from '../constants';
import ChatButton from '../ChatButton';
import type { ChatToggleHandler } from '../ChatButton';
import TooltipLabel from './TooltipLabel';

interface HeaderNavIconsProps {
	modules: Module[];
	activitiesCount: number;
	contextValue: DashboardContextValueInterface;
	setContextValue: React.Dispatch<React.SetStateAction<DashboardContextValueInterface>>;
	navigate: NavigateFunction;
	pathname: string;
	toggle: (handler: ChatToggleHandler) => void;
}

const HeaderNavIcons: React.FC<HeaderNavIconsProps> = ({
	modules,
	activitiesCount,
	contextValue,
	setContextValue,
	navigate,
	pathname,
	toggle,
}) => {
	const [chatOpen, setChatOpen] = useState(false);

	return (
		<div className="flex items-center gap-2">
			{showNavItem(import.meta.env.VITE_HEADER_SHOW_NOTIFICATIONS || '', pathname) && (
				<>
					{modules?.some((m) => m?.name === 'MRO' && m?.id === 6) && (
						<Tooltip position="down" slot={<TooltipLabel>MRO</TooltipLabel>}>
							<div className="">
								<Icon
									name="file-graph"
									style={{ fontSize: '20px' }}
									onClick={() => navigate('/mro-reports')}
								/>
							</div>
						</Tooltip>
					)}
					<Tooltip position="down" slot={<TooltipLabel>Source Health</TooltipLabel>}>
						<div className="">
							<Icon
								name="processor"
								style={{ fontSize: '20px' }}
								onClick={() => navigate('/health-dashboard')}
							/>
						</div>
					</Tooltip>
				</>
			)}
			{showNavItem(import.meta.env.VITE_HEADER_SHOW_NOTIFICATIONS ?? '', pathname) && (
				<Tooltip position="down" slot={<TooltipLabel>Notifications</TooltipLabel>}>
					<span style={{ position: 'relative', zIndex: 10 }}>
						<Badge count={contextValue.notificationCount ?? activitiesCount}>
							<Icon
								name="bell"
								className="cursor-pointer"
								style={{
									fontSize: '20px',
								}}
								onClick={() => {
									setContextValue((prev) => ({
										...prev,
										showNotifications: true,
									}));
								}}
							/>
						</Badge>
					</span>
				</Tooltip>
			)}
			<Tooltip position="down" title="HydroBot">
				<span>
					<Icon
						children={<ChatbotSvg />}
						name="ia-icon"
						className="cursor-pointer"
						style={{
							fontSize: '20px',
							marginRight: '5px',
							marginLeft: contextValue.notificationCount ? '20px' : '5px',
						}}
						onClick={() => setChatOpen((prev) => !prev)}
					/>
				</span>
			</Tooltip>
			<div>
				<ChatButton
					selectedLocation={contextValue.selectedLocation}
					selectedDate={contextValue.selectedDate}
					toggle={toggle}
					open={chatOpen}
				/>
			</div>
		</div>
	);
};

export default HeaderNavIcons;
